import Button from 'Components/button'
import { GlobalStoreContext } from 'Components/store'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { LoginStoreContext } from 'New/login/login-store'
import React, { useContext } from 'react'

export default function FollowStatus({
  className = '',
}: {
  className?: string
}) {
  const { state: globalState } = useContext(GlobalStoreContext)
  const { openLogin } = useContext(LoginStoreContext)
  const user_id = globalState?.userData?.user_id
  if (!user_id) {
    return (
      <div
        className={`${className} follow-status tw-flex tw-flex-col tw-items-center tw-justify-center`}
      >
        <p
          className={`tw-text-14 tw-leading-20 tw-mb-8 tw-text-video-shallow-gray`}
        >
          登录后，可查看您关注的车型
        </p>
        <Button
          className={`button`}
          type="new_primary"
          onClick={() => {
            /* eslint-disable no-unused-expressions */
            openLogin?.()
            sendTeaCommEvent('clk_event', {
              event_id: 'common_select_car_menu_login',
            })
          }}
        >
          快速登录
        </Button>
        <style jsx>
          {`
            :global(.follow-status .button) {
              @apply tw-h-32 tw-flex tw-font-normal tw-items-center tw-justify-center tw-pt-6 tw-pb-6 tw-pl-20 tw-pr-20 tw-text-14 tw-leading-20 !important;
            }
          `}
        </style>
      </div>
    )
  } else {
    return (
      <div
        className={`${className} tw-flex tw-flex-col tw-items-center tw-justify-center`}
      >
        <p
          className={`tw-text-14 tw-leading-20 tw-mb-8 tw-text-video-shallow-gray`}
        >
          您还未关注任何车型
        </p>
      </div>
    )
  }
}
